define(function(require, exports, module) {
    'use strict';

    const LoginBaseView = require('portlets/login/login.view');

    module.exports = LoginBaseView.extend({
        close: function() {
            window.fidoAuth.abortCurrent();

            LoginBaseView.prototype.close.apply(this, arguments);
        }
    });
});
